module.exports = __webpack_public_path__ + "img/login-snap.50786d5c.svg";